import React from 'react'
import { Card, CardGroup, Col, Row } from 'react-bootstrap'

const UniversityCampus = () => {
  return (
    <>
       <Card className='no-border rounded-0 architectural-modeling container'>
            <Card className='text-center no-border rounded-0'>
                <Card.Body>
                    <Card.Title className='architectural-modeling-title'> 大学キャンパス </Card.Title>
                    <Card.Text className='architectural-modeling-text text-left'>
                    私たちは、大学キャンパスの歴史的建造物をデジタルツインで再現し、入学希望者やその家族がバーチャルキャンパス内を見学できるように提供した実績があります。また、教室、研究室、社交場、スポーツ施設など、遠隔地にいる学生にも「キャンパス体験」を提供することができます。
                    <br />
                    <br />
                    Engage VRからMozilla Hubs、MicrosoftのAltspace VRからMetaのHorizon Worlds、VRChat、Roblox、Fortniteまで、あらゆる種類のVRプラットフォームに対応し、キャンパス、オフィス、工場、ファンタジー世界のデジタルツインを作成することができます。
                    </Card.Text>

                    <Row className='py-md-5 my-md-3'>
                        <Col md={{span:8, offset:2}}>
                            <Card.Img className='amazon-books-images' src={"/assets/digital-twin/university/images/university.jpg"} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={{span:12, offset:0}} md={{span:6, offset:0}}>
                            <CardGroup className='amazon-books-cardgroup'>
                                <Row>
                                    <Col md={{span:12, offset:0}}>
                                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                            <Card.Img className='university-images img-fluid' src={"/assets/digital-twin/university/images/uni_001.jpg"} />
                                            <Card.Body>
                                            <Card.Title className='architectural-modeling-footer-title'> 現実世界の大学校舎 <br /> （参考写真） </Card.Title>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={{span:12, offset:0}}>
                                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                            <Card.Img className='university-images img-fluid' src={"/assets/digital-twin/university/images/uni_001_01.jpg"} />
                                            <Card.Body>
                                            <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）の大学校舎 <br /> （3Dモデルのレンダリング画像）</Card.Title>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardGroup>
                        </Col>
                        <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className="py-md-0 py-5">
                            <CardGroup className='amazon-books-cardgroup'>
                                <Row>
                                    <Col md={{span:12, offset:0}}>
                                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                            <Card.Img className='university-images img-fluid' src={"/assets/digital-twin/university/images/uni_002.jpg"} />
                                            <Card.Body>
                                            <Card.Title className='architectural-modeling-footer-title'> 現実世界の大学校舎 <br /> （参考写真） </Card.Title>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={{span:12, offset:0}}>
                                        <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                            <Card.Img className='university-images img-fluid' src={"/assets/digital-twin/university/images/uni_002_01.jpg"} />
                                            <Card.Body>
                                            <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）の大学校舎 <br /> （3Dモデルのレンダリング画像）</Card.Title>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardGroup>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Card>
      
    </>
  )
}

export default UniversityCampus
